
export default {
  name: 'FilterCatalog',

  data: function () {
    return {
      filtersSelected: { ...this.selectedFilters },
      filtersSelectedTiporazmer: {},
      pricesFilter: { ...this.filterPrices },

      isSelectionCar: false,
      isOpenMobileMenu: false,
    };
  },

  props: {
    filters: {
      type: Array,
      default: () => [],
    },
    filterPrices: {
      type: Object,
      default: () => ({}),
    },
    selectedFilters: {
      type: Object,
      default: () => ({}),
    },
    sortOptions: {
      type: Array,
      default: () => [],
    },
    sortActive: {
      type: String,
      default: '',
    },
    carSlug: {
      type: String,
      default: '',
    },
    isUpdateLocalFilter: {
      type: Boolean,
      default: false,
    },
    sparkSlug: {
      type: String,
      default: '',
    },
  },

  computed: {
    visibleReset: function () {
      return Object.keys(this.selectedFilters || {}).length > 0;
    },
    visibleButtonCar: function () {
      return Boolean(this.filters.find((t) => t.slug === 'car'));
    },
    listSelectedFilters: function () {
      const selected = { ...(this?.selectedFilters || {}) };
      const filterList = this.filters || [];

      let list = [];
      if (selected?.priceFrom) {
        const priceFrom = Object.keys(selected?.priceFrom || {})?.[0];
        list.push({
          label: `от ${this.$numberFormat(priceFrom)} ₽`,
          filter: { slug: 'priceFrom' },
          slug: priceFrom,
        });
        delete selected.priceFrom;
      }
      if (selected?.priceTo) {
        const priceTo = Object.keys(selected?.priceTo || {})?.[0];
        list.push({
          label: `до ${this.$numberFormat(priceTo)} ₽`,
          filter: { slug: 'priceTo' },
          slug: priceTo,
        });
        delete selected.priceTo;
      }
      Object.keys(selected).map((filterKey) => {
        const filterItem = (this.filters || []).find((t) => t.slug === filterKey);
        const filterItemIndex = (this.filters || []).findIndex((t) => t.slug === filterKey);

        if (filterItem?.filterTemplate === 'checkbox_list_with_range' || filterItem?.filterTemplate === 'two_selects_range') {
          list.push({
            label: Object.keys(selected[filterKey] || {})?.[0],
            slug: Object.keys(selected[filterKey] || {})?.[0],
            filter: filterItem,
            sortIndex: filterItemIndex,
          });
        } else if (filterItem?.filterTemplate === 'pick_up_now') {
          list.push({
            label: this._replaceLabelVariantPickUpNow(filterItem),
            slug: Object.keys(selected[filterKey] || {})?.[0],
            filter: filterItem,
            sortIndex: filterItemIndex,
          });
        } else {
          Object.keys(selected[filterKey]).map((t) => {
            const variant = (filterItem?.variants || []).find((variant) => variant?.slug === t);
            list.push({
              ...variant,
              filter: filterItem,
              sortIndex: filterItemIndex,
            });
          });
        }
      });

      list = list.sort((a, b) => {
        if (a?.sortIndex > b?.sortIndex) {
          return 1;
        }
        if (a?.sortIndex < b?.sortIndex) {
          return -1;
        }
        return 0;
      });

      return list;
    },

    filterListCheckbox: function () {
      const filter = [...this.filters]
        .filter((t) => Boolean(Boolean(this.sparkSlug && t.slug !== this.sparkSlug) || !this.sparkSlug))
        .filter((t) => (t.filterTemplate !== 'type_sizes'))
        .filter((t) => (t.filterTemplate !== 'hidden'));

      // filter = filter.filter((t) => Boolean((t?.variants || []).length > 1));

      return filter;
    },
    filterListSizes: function () {
      return [...this.filters]
        .filter((t) => (t.filterTemplate !== 'hidden'))
        .filter((t) => (t.filterTemplate === 'type_sizes'));
    },
    filterTiporazmer: function () {
      return [...this.filters]
        .find((t) => (t.slug === this.sparkSlug));
    },

    buttonSelectionCarTitle: function () {
      const carDisappearance = Object.keys(this.selectedFilters?.car || {})?.['0'];
      if (!carDisappearance) {
        return 'Подобрать по авто';
      }

      const carValue = ((this.filters || []).find((t) => t.slug === 'car')?.variants || []).find((t) => t.slug === carDisappearance)?.label;
      if (!carValue) {
        return 'Подобрать по авто';
      }

      return carValue;
    },

    getActiveSort: function () {
      return (this.sortOptions || []).find((t) => t.id === (this.sortActive || 'default'))?.value;
    },

    textHelpHowGetParams: function () {
      return this.$store.state.appState?.vars?.['Подсказка каталоге "Где смотреть параметры"'];
    },

    isUpdateFilters: function () {
      return this.$store.state.loading?.updateFilters;
    },
    isLoadingFilters: function () {
      return false;
      return Boolean(
        this.$store.state.appState?.loading?.filters
        || this.$store.state.appState?.loading?.category,
      );
    },
    isVisibledSectionSizes: function () {
      return Boolean(this.filterListSizes.length && !this.selectedFilters?.tiporazmer || true);
    },

    filterPickUpNow: function () {
      return (this.filters || []).filter((t) => Boolean(t.filterTemplate === 'pick_up_now'));
    },
  },

  components: {
    SectionSize: () => import('~/components/filter/SectionSize'),
    SectionPrice: () => import('~/components/filter/SectionPrice'),
    SectionRadio: () => import('~/components/filter/SectionRadio'),
    SectionCheckbox: () => import('~/components/filter/SectionCheckbox'),
    SectionCheckboxRange: () => import('~/components/filter/SectionCheckboxRange'),
    SectionSelectsRange: () => import('~/components/filter/SectionSelectsRange'),
    SectionPickUpNow: () => import('~/components/filter/SectionPickUpNow'),
    SectionCars: () => import('~/components/filter/SectionCars'),

    SortDropdown: () => import('~/components/catalog/SortDropdown'),
  },

  watch: {
    selectedFilters: function () {
      this.filtersSelected = { ...this.selectedFilters };
    },
    filterPrices: function () {
      this.pricesFilter = { ...this.filterPrices };
    },
  },

  methods: {
    tapVariant: function (filterSlug, variantSlug) {
      const filterTemplate = (this.filters || []).find((t) => t.slug === filterSlug)?.filterTemplate || '';

      // Изменение текущего фильтра
      const filtersSelected = { ...this.filtersSelected };

      if (filtersSelected?.[filterSlug]?.[variantSlug]) {
        delete filtersSelected?.[filterSlug]?.[variantSlug];
        if (Object.keys(filtersSelected?.[filterSlug] || {}).length <= 0) {
          delete filtersSelected?.[filterSlug];
        }
      } else if (filterTemplate === 'radio_buttons') {
        filtersSelected[filterSlug] = {
          [variantSlug]: variantSlug,
        };
      } else {
        filtersSelected[filterSlug] = {
          ...(filtersSelected[filterSlug] || {}),
          [variantSlug]: variantSlug,
        };
      }

      // При выборе "Тип шины" добавляем фильтр сезон зима
      const isSeasonZima = Boolean(((this.filters || []).find((t) => t.slug === 'season')?.variants || []).find((t) => t.slug === 'zima'));
      if (filterSlug === 'spikes' && isSeasonZima) {
        filtersSelected.season = {
          ...(filtersSelected.season || {}),
          zima: 'zima',
        };
      }

      // При выборе "Грязевая" добавляем фильтр сезон Грязевая
      const isSeasonLeto = Boolean(((this.filters || []).find((t) => t.slug === 'season')?.variants || []).find((t) => t.slug === 'zima'));
      if (filterSlug === 'gryazevaya' && isSeasonLeto) {
        filtersSelected.season = {
          ...(filtersSelected.season || {}),
          leto: 'leto',
        };
      }

      if (filterSlug === 'season') {
        delete filtersSelected.spikes;
        delete filtersSelected.gryazevaya;
      }

      this.filtersSelected = filtersSelected;
      this.$emit('getUpdateFilters', filtersSelected);
    },
    tapVariantSize: function (filterSlug, variantSlug) {
      const filtersSelected = { ...this.filtersSelected };
      if (filtersSelected?.[filterSlug]?.[variantSlug]) {
        delete filtersSelected?.[filterSlug]?.[variantSlug];
        if (Object.keys(filtersSelected?.[filterSlug] || {}).length <= 0) {
          delete filtersSelected?.[filterSlug];
        }
      } else {
        filtersSelected[filterSlug] = {
          [variantSlug]: variantSlug,
        };
      }
      this.filtersSelected = filtersSelected;
      this.$emit('getUpdateFilters', filtersSelected);
    },

    changePrice: function (pricesFilter) {
      this.pricesFilter = pricesFilter;
    },
    changeFiltersSelected: function (filtersSelected) {
      this.filtersSelected = filtersSelected;
      this.$emit('getUpdateFilters', filtersSelected);
    },

    changeSelectionCar: function () {
      this.$store.commit('pop-up-select-transport/setOpen', true, {
        slug: this.carSlug,
      });
    },
    changeSelectionCarValue: function (value) {
      this.$store.commit('pop-up-select-transport/setOpen', value);
    },

    changeOpenMobileMenu: function () {
      const isOpenMobileMenu = !this.isOpenMobileMenu;
      this.isOpenMobileMenu = isOpenMobileMenu;
      if (!isOpenMobileMenu) {
        this.$emit('getUpdateFilterFull');
      }
    },

    _visibleCheckboxList: function (filter, visibleTemplate) {
      // При сезоне лето скрывать тип шин
      if (this.selectedFilters?.season?.leto && !this.selectedFilters?.season?.zima && filter?.slug === 'spikes') {
        return false;
      }

      // При сезоне зима скрывать Грязевая
      if (this.selectedFilters?.season?.zima && !this.selectedFilters?.season?.leto && filter?.slug === 'gryazevaya') {
        return false;
      }

      return Boolean(filter?.filterTemplate === visibleTemplate);
    },
    _replaceLabelVariantPickUpNow: function (filter, variant) {
      if (filter?.slug === 'polucit-segodna-posle-1500') {
        const dateNew = new Date();
        const userTimezoneOffset = Math.abs(dateNew.getTimezoneOffset() * 60000);
        const dateGrinwich = dateNew.getTime() - userTimezoneOffset;
        const dateEkaterinburg = dateGrinwich + (300 * 60000);

        const hours = new Date(dateEkaterinburg).getHours();

        if (hours >= 13) {
          return 'Получить завтра после 15:00';
        }
        return 'Получить сегодня после 15:00';
      }

      return filter?.nameForFilter || filter?.name;
    },
  },
};
